
// AEP screener (#679): asks a client which Medicare situation this call is
// for — new-to-Medicare vs. an existing plan review. Values match the
// backend ConsultReason enum exactly ('new_to_medicare' | 'plan_review')
// so the wizard can send `reason` straight through on /book/.
export default {
    props: {
        value: { type: String, default: null },
    },
    methods: {
        select (reason) {
            this.$emit('input', reason)
        },
    },
}
